import React from 'react'

import { Type as InputType } from 'components/base/Form/Input/Input'
import { InputField } from 'components/base/Form/Input/Input/styles'

import { Props } from './types'

import {
  SubInputGroup,
  SubInputLabel,
  Wrapper,
} from './styles'

const Date: React.FC<Props> = ({
  inputs,
  name,
  onBlur,
  onChange,
  touched,
  valid,
  ...props
}): React.ReactElement => (
  <Wrapper {...props}>
    <SubInputGroup>
      <SubInputLabel>Month</SubInputLabel>
      <InputField
        autoComplete={name || 'off'}
        name={(name && `${name}-month`) || ''}
        min='1'
        max='12'
        onBlur={onBlur}
        onChange={onChange}
        placeholder='MM'
        pristine={!touched}
        ref={inputs.month.ref}
        touched={touched}
        type={InputType.number}
        valid={valid}
        value={inputs.month.value || ''}
      />
    </SubInputGroup>
    <SubInputGroup>
      <SubInputLabel>Day</SubInputLabel>
      <InputField
        autoComplete={name || 'off'}
        name={(name && `${name}-day`) || ''}
        min='1'
        max='31'
        onBlur={onBlur}
        onChange={onChange}
        placeholder='DD'
        pristine={!touched}
        ref={inputs.day.ref}
        touched={touched}
        type={InputType.number}
        valid={valid}
        value={inputs.day.value || ''}
      />
    </SubInputGroup>
    <SubInputGroup>
      <SubInputLabel>Year</SubInputLabel>
      <InputField
        autoComplete={name || 'off'}
        name={(name && `${name}-year`) || ''}
        min='1900'
        onBlur={onBlur}
        onChange={onChange}
        placeholder='YYYY'
        pristine={!touched}
        ref={inputs.year.ref}
        touched={touched}
        type={InputType.number}
        valid={valid}
        value={inputs.year.value || ''}
      />
    </SubInputGroup>
  </Wrapper>
)

export default Date
